module.exports = __webpack_public_path__ + "img/icon--twitter.da43cdfd.svg";